// src/components/productPage/singleProductPageComponents/ysim/DatasetToggles.tsx
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import type { ChartDatasetWithAxis } from './types';
import { S_PARAM_LABELS } from './types';

interface Props {
    datasets: ChartDatasetWithAxis[];
    selected: string[];
    onToggle: (label: string) => void;
}

export default function DatasetToggles({ datasets, selected, onToggle }: Props) {
    const mainList = datasets.filter(
        (d, i, self) =>
            !S_PARAM_LABELS.includes(d.label as any) &&
            i === self.findIndex((x) => x.label === d.label)
    );

    const sParams = datasets.filter((d) => S_PARAM_LABELS.includes(d.label as any));

    return (
        <>
            <FormGroup row sx={{ justifyContent: 'center', mb: 1 }}>
                {mainList.map((d) => (
                    <FormControlLabel
                        key={d.label}
                        control={
                            <Checkbox
                                checked={selected.includes(d.label)}
                                onChange={() => onToggle(d.label)}
                                style={{ color: d.borderColor }}
                            />
                        }
                        label={d.label}
                    />
                ))}
            </FormGroup>

            <FormGroup row sx={{ justifyContent: 'center' }}>
                {sParams.map((d) => (
                    <FormControlLabel
                        key={d.label}
                        control={
                            <Checkbox
                                checked={selected.includes(d.label)}
                                onChange={() => onToggle(d.label)}
                                style={{ color: d.borderColor }}
                            />
                        }
                        label={d.label}
                    />
                ))}
            </FormGroup>
        </>
    );
}
